/**
 * LocationsGate — capability gate for Locations pages.
 *
 * Route-level ProtectedRoute only knows roles, but Locations capabilities are "role OR right"
 * (a user may hold Location.View without a Locations role), so pages ask useLocationsPermissions.
 */

import type { ReactNode } from 'react';
import { IconLock } from '@tabler/icons-react';
import { LayoutContainer } from '@/components/ui/layout';
import { EmptyState } from '@/components/ui/data-display';
import { useLocationsPermissions, type LocationsPermissions } from '@/hooks/locations/useLocationsPermissions';

interface LocationsGateProps {
  allow: (p: LocationsPermissions) => boolean;
  children: ReactNode;
}

export function LocationsGate({ allow, children }: LocationsGateProps) {
  const perms = useLocationsPermissions();
  if (!allow(perms)) {
    return (
      <LayoutContainer>
        <EmptyState
          icon={<IconLock size={40} />}
          title="Access denied"
          description="You do not have permission to open this page. Ask a Locations administrator for access."
        />
      </LayoutContainer>
    );
  }
  return <>{children}</>;
}
